import API from '../services/api';

const api = new API();

const URL_FRAUD_DATA = '/api/get_new_data';
const URL_REPORTING_DATES = '/api/users/get_report_dates';

const unwrapLegacyResponse = response => {
    if (response.status !== 0) {
        return Promise.reject(response.value);
    }
    return response.value;
};

export function fetchFraudWidgetData({ startDate, endDate, channel, ...params }) {
    return api
        .getJson(URL_FRAUD_DATA, {
            method: 'POST',
            credentials: 'include',
            body: {
                is_default: true,
                display_unenriched: false,
                display_admon_alignment: false,
                is_dashboard: false,
                chart: false,
                is_fraud: true,
                start_date: startDate,
                end_date: endDate,
                cohort_metrics: [],
                filters: [],
                time_breakdown: ['all'],
                ...params,
            },
            cache: false,
            unique: true,
            channel: channel || 'fraud',
        })
        .then(unwrapLegacyResponse);
}

export function fetchDefaultDates() {
    return api
        .getJson(URL_REPORTING_DATES, {
            method: 'GET',
            credentials: 'include',
            cache: true,
        })
        .then(unwrapLegacyResponse);
}
